import React, { Component } from 'react';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import axios from 'axios';
import {FormattedHTMLMessage} from 'react-intl';
import CustomSpinner from './CustomSpinner.js'
import LeadInfo from './LeadInfo.js';
import Header from './Header.js';

class Congratulations extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hash_id: null,
            provider_phone: null
        };
    }

     componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/congratulations`, config);

    }

    render() {
        const { clientName } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <Header>
                        <div className="congrats-circle">
                            <div className="congrats-circle-inner">
                                100%
                            </div>
                        </div>
                        <FormattedHTMLMessage id="app.step_congratulations" description="Congratulations info" values={{ nameClient: clientName, }} />
                    </Header>
                    <div className='container no-gutters'>
                        <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                            <div className="pvc-form congratulations-container">
                                <div className="congrats-dialog">
                                    <div className="congrats-dialog-arrow"></div>
                                    {this.props.isLoading && <CustomSpinner message='Estamos buscando tu auto ideal' />}
                                    <p><span className='custom-red-font'>¡Felicitaciones {clientName}!</span></p>
                                    <p>Encontraste la financiación que se adapta a vos.</p>
                                    <p>Te enviamos un correo electrónico con todos los documentos completos de la solicitud online. Nos comunicaremos en breve para comentarte los pasos a seguir</p>
                                    <h4><b>¡Pusiste primera y tu auto ya está en marcha!</b></h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

Congratulations = TopScrolleable(Congratulations);

Congratulations = LeadInfo(Congratulations);

Congratulations = withAuthControl(Congratulations);

export default Congratulations;



/** WEBPACK FOOTER **
 ** ./src/components/Congratulations.js
 **/